import { render, staticRenderFns } from "./TableSearchBar.vue?vue&type=template&id=8d56c134&scoped=true"
import script from "./TableSearchBar.vue?vue&type=script&lang=ts"
export * from "./TableSearchBar.vue?vue&type=script&lang=ts"
import style0 from "./TableSearchBar.vue?vue&type=style&index=0&id=8d56c134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d56c134",
  null
  
)

export default component.exports